export default __webpack_public_path__ + "static/catacombs-f3d95a60e82667072fefb7d84abd3f78.jpg";